export const ENDORSERS = [
  {
    name: 'Austin Chronicle',
    description: 'Progressive · Central Texas',
    url: 'https://www.austinchronicle.com/elections/',
    lean: 'left',
  },
  {
    name: 'League of Women Voters',
    description: 'Nonpartisan · all races',
    url: 'https://www.vote411.org/',
    lean: 'nonpartisan',
  },
  {
    name: 'Williamson County GOP',
    description: 'Conservative · Williamson County',
    url: 'https://www.wilcogop.org/',
    lean: 'right',
  },
  {
    name: 'Battleground Texas',
    description: 'Progressive · statewide',
    url: 'https://www.battlegroundtexas.com/',
    lean: 'left',
  },
  {
    name: 'Texas Tribune',
    description: 'Nonpartisan · news & voter guide',
    url: 'https://www.texastribune.org/elections/',
    lean: 'nonpartisan',
  },
  {
    name: 'Ballotpedia',
    description: 'Nonpartisan · all races, all levels',
    url: 'https://ballotpedia.org/',
    lean: 'nonpartisan',
  },
];
